import renderHTML from 'react-render-html'

import { brandCurrencyPrefixes } from '../../configuration/brand'

export default function formatPrice(figure, decimals, enableSuperScript) {
  if (!decimals) decimals = 0
  const d = Math.pow(10, decimals)

  if (enableSuperScript) {
    let priceValue = parseInt(figure * d, 0) / d
    priceValue = priceValue.toFixed(decimals).split('.')

    return renderHTML(`${priceValue[0]}<sup>.${priceValue[1]}</sup>`)
  }
  return (parseInt(figure * d, 0) / d).toFixed(decimals)
}

export function addBrandCurrencyPrefix(brandCode, figure) {
  const prefix = brandCurrencyPrefixes[brandCode] || '$'
  return figure ? `${prefix}${figure.toLocaleString()}` : prefix
}
